import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import pl from './locales/pl.json';
import en from './locales/en.json';

// Each published site is built for one language (see scripts/build-sites.js),
// so the detector only runs during local development.
const forcedLng = process.env.REACT_APP_LOCALE;

const instance = i18n.use(initReactI18next);
if (!forcedLng) instance.use(LanguageDetector);

instance.init({
  resources: {
    pl: { translation: pl },
    en: { translation: en }
  },
  lng: forcedLng || undefined,
  fallbackLng: 'pl',
  detection: {
    order: ['localStorage', 'navigator'],
    caches: ['localStorage']
  },
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
